import Arrow from '../../assets/icons/arrow.inline.svg';
import Argo from '../../assets/images/argo.inline.svg';
import Code from '../../assets/icons/code.inline.svg';
import Document from '../../assets/icons/document.inline.svg';
import Github from '../../assets/icons/github.inline.svg';
import Information from '../../assets/icons/information.inline.svg';
import NumberOne from '../../assets/icons/numberOne.inline.svg';
import NumberTwo from '../../assets/icons/numberTwo.inline.svg';
import NumberThree from '../../assets/icons/numberThree.inline.svg';
import NumberFour from '../../assets/icons/numberFour.inline.svg';
import Number1 from '../../assets/icons/number1.inline.svg';
import Number2 from '../../assets/icons/number2.inline.svg';
import Number3 from '../../assets/icons/number3.inline.svg';
import Number4 from '../../assets/icons/number4.inline.svg';
import Points from '../../assets/icons/points.inline.svg';
import ServiceDetails from '../../assets/images/service-details.inline.svg';
import ShareKnow from '../../assets/images/share-know.inline.svg';
import ShareSee from '../../assets/images/share-see.inline.svg';
import Timer from '../../assets/icons/timer.inline.svg';
import Tools from '../../assets/icons/tools.inline.svg';
import Pyramid from '../../assets/images/pyramid.inline.svg';
import PyramidAll from '../../assets/images/pyramid-all.inline.svg';

const icons = new Map();
icons.set('arrow', Arrow);
icons.set('argo', Argo);
icons.set('code', Code);
icons.set('document', Document);
icons.set('github', Github);
icons.set('information', Information);
icons.set('number-one', NumberOne);
icons.set('number-two', NumberTwo);
icons.set('number-three', NumberThree);
icons.set('number-four', NumberFour);
icons.set('number-1', Number1);
icons.set('number-2', Number2);
icons.set('number-3', Number3);
icons.set('number-4', Number4);
icons.set('points', Points);
icons.set('service-details', ServiceDetails);
icons.set('share-know', ShareKnow);
icons.set('share-see', ShareSee);
icons.set('timer', Timer);
icons.set('tools', Tools);
icons.set('pyramid', Pyramid);
icons.set('pyramid-all', PyramidAll);

export default icons;
